import { EventType } from '@woovi/shared';

import { notifyListeners } from './notifyListeners.tsx';
import PixDialogWrapper from './PixDialogWrapper.tsx';
import useStoreContext from '../store/useStoreContext.tsx';

import type { ReactNode } from 'react';

const PixApp = (): ReactNode => {
  const { openPixState, setOpenPixState } = useStoreContext();
  const onClose = () => {
    notifyListeners({
      type: EventType.ON_CLOSE,
      data: {},
    });

    setOpenPixState({
      isOpen: false,
      value: null,
      description: null,
      // correlationID: null,
      // discuss this
      customer: openPixState.customer,
      config: openPixState.config,
      success: false,
    });
  };

  const onCloseSuccess = () => {
    setOpenPixState({
      isOpen: false,
      value: null,
      description: null,
      correlationID: null,
      // discuss this
      customer: openPixState.customer,
      config: openPixState.config,
      success: false,
    });
  };

  return <PixDialogWrapper onClose={onClose} onCloseSuccess={onCloseSuccess} />;
};

export default PixApp;
